import { Component } from '@angular/core';

@Component({
  selector: 'app-register-verify-page',
  templateUrl: './register-verify-page.component.html',
  styleUrls: ['./register-verify-page.component.scss']
})
export class RegisterVerifyPageComponent {}
